namespace Client.InfrastructureTypes

open Fulma

[<RequireQualifiedAccess>]
module Container =
    let isFullWidth = Container.CustomClass "full-width"